import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ShareddtaService } from './shareddta.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketRefreshService {

  private socket: WebSocket | null = null;
  private connectionStatus = false;
  private messageHandler: ((event: MessageEvent) => void) | undefined;
  private manuallyDisconnected = false;
  port = environment.port;

  constructor(private shared: ShareddtaService) {}

  // ---------------- CONNECT ----------------
  public connect() {

    if (this.connectionStatus) {
      console.log("Refresh WS already connected.");
      return;
    }

    this.manuallyDisconnected = false;
    this.openConnection();
  }

  private openConnection() {

    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      return;
    }

    let org = localStorage.getItem("org_domain");
    let schema = localStorage.getItem("schema_name");
    let token = localStorage.getItem("access_token");

    if (!org || !schema) {
      console.error("Missing schema_name / org_domain");
      return;
    }

    const host = new URL(org).hostname;

    try {
      this.socket = new WebSocket(
        `wss://${host}:${this.port}/ws/order_list/${schema}/?token=${token}`
      );
    } catch (error) {
      console.error("WebSocket creation failed:", error);
      return;
    }

    this.socket.onopen = () => {
      this.connectionStatus = true;
      console.log("Refresh WebSocket Connected");

      if (this.messageHandler) {
        this.socket!.onmessage = this.messageHandler;
      }
    };

    this.socket.onclose = () => {
      this.connectionStatus = false;
      console.log("Refresh WebSocket Closed");

      if (!this.manuallyDisconnected) {
        this.reconnect();
      }
    };

    this.socket.onerror = (error) => {
      console.error("Refresh WebSocket Error:", error);
    };

    const handler = (event: MessageEvent) => {

      try {
        console.log("Refresh WS Received:", event.data);

        let data = JSON.parse(event.data);

        if (data && data.result && data.result.action) {

          if (data.result.action === "order_list") {
            this.shared.refreshData(data);
          }
          else if (data.result.action === "new_order") {
            this.shared.refreshData1(data);
          }

        }

      } catch (e) {
        console.error("WebSocket JSON parse error:", e);
      }

    };

    this.messageHandler = handler;
    this.socket.onmessage = handler;
  }

  // --------------- RECONNECT ---------------
  private reconnect() {

    setTimeout(() => {

      if (!this.connectionStatus && !this.manuallyDisconnected) {
        console.log("Reconnecting refresh WebSocket...");
        this.openConnection();
      }

    }, 3000);
  }

  // ---------------- SEND FILTERS ----------------
  public sendOrderListRequest(data: any) {

    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      console.warn("Refresh WS not ready.");
      return;
    }

    const payload = {
      action: "order_list",
      page: (data.page ?? 0) + 1,
      page_size: data.page_size || 20,
      filters: {
        search_text: data.search_text || "",
        order_date: data.order_date || "",
        order_status: data.order_status || "",
        order_type: data.order_type || "",
        driver_ids: data.driver_ids || []
      }
    };

    console.log("Refresh WS Payload Sending:", payload);
    this.socket.send(JSON.stringify(payload));
  }

  public sendOrderListRequestpending(data: any) {

    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      console.warn("Refresh WS not ready.");
      return;
    }

    const payload = {
      action: "new_order",
      order_id: data.orderid,
      page: 4,
      page_size: data.page_size || 20,
      filters: {
        search_text: data.search_text || "",
        order_date: data.order_date || "",
        order_status: data.order_status || "",
        order_type: data.order_type || "",
        driver_ids: data.driver_ids || []
      }
    };

    console.log("Refresh WS Payload Sending:", payload);
    this.socket.send(JSON.stringify(payload));
  }

  // ---------------- DISCONNECT ----------------
  public disconnect() {

    if (this.socket) {
      this.manuallyDisconnected = true;
      this.socket.close();
      this.socket = null;
      this.connectionStatus = false;
    }
  }
}
